<template>
  <div class="page_analysis">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
            <div class="screenInputs">
            <div class="screenInput">
                <el-input size="small" clearable placeholder="请输入项目名称" v-model="listQuery.custname" @keyup.enter.native="getList()"></el-input>
                <span style="margin-left:10px">记账日期:</span>
                <el-date-picker
                    v-model="listQuery.bookingRealMonth"
                    type="month"
                    :clearable="false"
                    value-format="yyyy-MM">
                </el-date-picker>
                <span style="margin-left:10px">归属日期:</span>
                <el-date-picker
                    v-model="listQuery.belongMonth"
                    type="month"
                    clearable
                    value-format="yyyy-MM">
                </el-date-picker>
                <el-button type="success" plain size="small" @click="searchEnterFun" style="margin-left:5px">搜索</el-button>
            </div>
            </div>
        </div>
        <div class="top-right">
            <el-button type="success" size="small" plain @click="dropDownScreen">
            筛选
            </el-button>
            <el-button type="primary" plain size="small" style="margin-right:20px" @click="exportHandle" :loading="exportLoading" v-show="tableData.length>0&&!isNull(tableData)">导出</el-button>
        </div>
        <!-- 筛选下拉框 -->
        <div class="dropDownScreen" v-show="showDropScreen==1">
            <div class="inputs">
            <div class="formScreenInput">
                <div>服务中心</div>
                <el-select v-model="listQuery.strSrvCent" slot="prepend" placeholder="请选择" filterable @change="serviceChange">
                <el-option v-for="(item,index) in serviceList" :key="index" :label="item.StrSrvCent" :value="item.StrSrvCent"></el-option>
                </el-select>
            </div>
            </div>
            <div class="drop-footer">
            <button class="clear" style="margin-right:10px" @click="resetHandle">清空</button>
            <button class="search" @click="searchEnterFun">搜索</button>
            <button class="clear" @click="showDropScreen=-1">关闭</button>
            </div>
        </div>
    </div>
    <div class="main-con">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="page_crumb">
            <el-breadcrumb-item>财务分析</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/employee-analysis' }">项目列表</el-breadcrumb-item>
            <el-breadcrumb-item v-if="strTableId=='XZ_emp_FnncSocialInsu'">项目收支表社保</el-breadcrumb-item>
            <el-breadcrumb-item v-else-if="strTableId=='XZ_emp_FnncProCost'">项目收支表费用</el-breadcrumb-item>
            <el-breadcrumb-item v-else-if="strTableId=='XZ_emp_FnncProfit'">利润表</el-breadcrumb-item>
            <el-breadcrumb-item v-else-if="strTableId=='XZ_emp_FnncProjectInvoice'">项目开票信息表</el-breadcrumb-item>
        </el-breadcrumb>
      <div class="crumbs" style="width: 99%">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="项目总计" name="first"></el-tab-pane>
            <el-tab-pane label="人员总计" name="second"></el-tab-pane>
            <el-tab-pane label="总计对比" name="third"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="funcsumTable">
            <tree-table :data="tableData" :columns="tableTitle" border/>
        <div class="block" style="width: 99%">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
           @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="Number(listQuery.pagecount)"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "./../../common";
// import treeTable from "./../../components/treeTable/index.vue";
import { parseTime } from './../../utils' //格式化时间格式
export default {
    props: {
    toChildrenData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
// components: { treeTable },
  data() {
    return {
      expandAll:false,
      tableHeight: 0,
      listLoading: false,
      totalcount: null,
      index: '',
      tableData: [],
      //列表参数
      listQuery: {
        pagecount: 10,
        currpage: 1,
        strallObjName: "",
        tableid: "XZ_analysis_InvoiceCollection",
        strObjName: "",
        bookingRealMonths: "",
        belongMonths: "",
        strSrvCent: "", //服务中心
      },
      //切换tab
      activeName: "first",
      //导出参数
      exportQuery: {
        pagecount: 1000000,
        currpage: 1,
        custname: "",
        tableid: "XzFinance",
        username: "",
        idcard: "",
        bookingRealMonth: "",
        belongMonth: "",
        looktype: 2, //1 人员总计详情  2 项目总计
      },
      //下拉服务中心列表
      serviceList: [],
      //导出按钮加载状态
      exportLoading: false,
      //人员角色
      loginRoletype: "",
      //下拉筛选
      showDropScreen: -1,
      //表头数据
      tableTitle: [],
      //是否展开
      expandChange: false,
      strTableId: "",
      //表名数据
      tableNameList:[]
    };
  },
  async created() {
    this.closeAccountType = localStorage.closeAccountType;
    this.loginRoletype = localStorage.loginRoletype;
    this.calHeight();
    await this.getTableList()
    this.getServiceList();
    this.getList();
  },
  methods: {
    rowClassName({ row, rowIndex }) {
      // console.log("rowClassName", row, rowIndex);
      return row.children ? "haveChildren" : "noHave";
    },
    tableDataClick(row, column, event) {
      // if (!this.isNull2(row.children) && row.children.length > 0) {
      //   for (let index = 0; index < row.children.length; index++) {
      //     row.children.id = index + new Date().getTime() + Math.random() * 1000;
      //   }
      // }
      this.$refs.tableData.toggleRowExpansion(row, !row.expand);
      row.expand = !row.expand;
    },
    // 通过表头关连拿到数据
    toGetColumData(item) {
      // let id =  item.StrColumId;
      // console.log(item);
      return true;
    },
    expandHandle(row, data) {
      // 展开 但是手动给他关掉
      if (!row.children) {
        this.$refs.tableData.toggleRowExpansion(row, false);
      }
      // console.log('row',row)
      // if (!this.isNull2(row.children) && row.children.length > 0) {
      //   for (let index = 0; index < row.children.length; index++) {
      //     row.children.id = index + new Date().getTime() + Math.random() * 1000;
      //   }
      // }
    },
    //切换tab
    async handleClick(tab, event) {
      console.log('tab',tab, event);
      this.listQuery.currpage = 1;
      this.exportQuery.currpage = 1;
      this.listQuery.tableid = 2;
      this.exportQuery.tableid = 2;
      this.getList();
    },
    //导出
    exportHandle() {
      //    this.exportQuery.custname = this.listQuery.custname
      //    this.exportQuery.idcard = this.listQuery.idcard
      //    this.exportQuery.bookingRealMonth = this.listQuery.bookingRealMonth
      //    this.exportQuery.belongMonth = this.listQuery.belongMonth
      //    if(this.isNull(this.listQuery.bookingRealMonth)){
      //        this.$message({
      //         showClose: true,
      //         message: "请选择记账日期",
      //         type: "warning"
      //       });
      //       return false
      //    }else{
      //       this.exportLoading = true
      //       xz.reportfinanceCurrDataTable(this.exportQuery).then(res => {
      //           // console.log('process', res)
      //           if(res.status == 'ok'){
      //           this.$router.push({
      //               path: "/employee-fnnchis",
      //               query: {
      //               showPage: 1,
      //               isActive: 1,
      //               custname: res.msg,
      //               //qStstus=1时查看最后一条导出记录
      //               qStstus: 1
      //               }
      //           })
      //           }else{
      //             this.$message({
      //                 message: "导出错误，请稍后再试",
      //                 type: "error"
      //             });
      //           }
      //           this.exportLoading = false
      //       })
      //    }
    },
    //搜索
    searchEnterFun() {
      this.getList();
      this.showDropScreen == -1;
    },
    //筛选下拉
    dropDownScreen() {
      this.showDropScreen = !this.showDropScreen;
    },
    serviceChange() {
      this.getList();
    },
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      // console.log('height',this.tableHeight)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.listQuery.currpage = parseInt(val);
      this.getList();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.listQuery.currpage = 1;
      this.listQuery.pagecount = parseInt(val);
      this.getList();
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "1900/01/01" ||
        o == "1900-01-01T00:00:00" ||
        o == "1900-01-01"
      );
    },
    isNull2(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o === "" ||
        o == "null" ||
        o == []
      );
    },
    getList() {
      xz.getAnalysisTotalData(this.listQuery).then((res) => {
        // console.log("getList", res);
        if (res && res.msg.parent.length > 0) {
          let parentList = res.msg.parent
          for (let index = 0; index < parentList.length; index++) {
              parentList[index].id = index + new Date().getTime() + Math.random() * 1000;
              parentList[index].hasChildren = true
              this.recursiveFun(index,parentList[index].children)
            }
          this.tableData = parentList
          // console.log('ll',this.tableData)
          this.totalcount = res.msg.totalcount
        } else {
          this.tableData = []
          this.totalcount = 0
        }
      });
    },
    //设置列表id
    recursiveFun(index,data){
        this.getIDfun(index,data)//需要循环执行的方法
    },
    getIDfun(index,data){
      ++index;
       let dataIndex = data[0]
      this.$set(dataIndex,"id",index+'c' + new Date().getTime() + Math.random() * 1000);
      this.$set(dataIndex,"hasChildren",true);
       //判断执行方法的条件（满足什么条件时停止循环执行）
      if(data&&index<data.length){
            this.recursiveFun(index,data) 
      }
    },
    //下拉服务中心列表
    getServiceList() {
      xz.getsrarchinstlist().then((res) => {
        // console.log("getServeList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({ StrSrvCent: service.Strinstname });
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
      });
    },
    //表名列表
    getTableList(){
      xz.getAnalysisTable().then((res) => {
        // console.log("getTableList", res);
        if (res && res.msg.data.length > 0) {
          this.tableNameList = res.msg.data
          this.strTableId = res.msg.data[0].StrTableId
          this.getTitleList()
        } else {
          this.tableNameList = []
        }
      });
    },
    //获取一级表头列表
    getTitleList(){
      xz.getAnalysisColumnInf(this.strTableId).then((res) => {
        // console.log("tableid", res);
        if (res && res.length > 0) {
          this.tableTitle = res
        } else {
          this.tableTitle = []
        }
      });
    },
    //清空
    resetHandle() {
      this.listQuery.pagecount = 10;
      this.listQuery.currpage = 1;
      this.listQuery.strSrvCent = ""; //服务中心
    },
  },
};
</script>
<style scoped>
.page_crumb{
    width: 100%;
    margin: 15px 0;
}
</style>
<style>
.page_analysis .formScreenInput .el-input__inner{
  width: 210px;
}
.page_analysis .el-tabs__header{
    margin: 0;
}
.page_analysis .screenInput .el-input{
    width: 180px;
}
.page_analysis .screenInput .el-date-editor.el-input{
    width: 130px;
}
.page_analysis .el-date-editor .el-input__inner{
height: 32px;
line-height: 32px;
}
.page_analysis .el-date-editor .el-input__icon{
    line-height: 33px;
}
.page_analysis .el-select .el-input__inner{
  height: 32px;
  line-height: 32px;
}
.page_analysis .el-select .el-input__icon{
  line-height: 32px;
}
</style>